export const UpdatesPage: React.FC = () => {
  return <Blog />
}

const posts = [
  {
    id: 1,
    title: "Hello world",
    description:
      "The site is live! It's not fully complete but you can create time capsules and entries to them. Next up is working on profile stuff, and probably getting the rest of the basic functionality in place.",
    date: "Nov 12, 2024",
    datetime: "2024-11-12",
    category: { title: "Update" },
    author: {
      name: "Matzie"
    }
  },
  {
    id: 2,
    title: "Profile page",
    description:
      "Just added a profile page where you can see your profile image, name, and email. You can also update your profile image and name. Also make sure to resend the verification email since it wasnt in place before, so you've never had any email sent. This created the file upload functionality so that makes it easier to add files to the time capsule entries.",
    date: "Nov 18, 2024",
    datetime: "2024-11-18",
    category: { title: "Update" },
    author: {
      name: "Matzie"
    }
  },
  {
    id: 3,
    title: "Time capsule settings",
    description:
      "You can now edit your time capsules! Very nice. You can change the name and the opens at date and also delete it completely.",
    date: "Nov 19, 2024",
    datetime: "2024-11-19",
    category: { title: "Update" },
    author: {
      name: "Matzie"
    }
  },
  {
    id: 4,
    title: "Sharing is caring",
    description:
      "You can now share your time capsules with others! Add entries together and when it opens, you can all see what you've added.",
    date: "Dec 4, 2024",
    datetime: "2024-12-04",
    category: { title: "Update" },
    author: {
      name: "Matzie"
    }
  },
  {
    id: 5,
    title: "Production ready",
    description:
      "Added most of the stuff thats needed for the site, missing some empty states and probably some other stuff. But it's good enough for now. Next up is fixing those edge cases and maybe improve some design. If you have any feedback, please let me know ❤️",
    date: "Dec 16, 2024",
    datetime: "2024-12-16",
    category: { title: "Update" },
    author: {
      name: "Matzie"
    }
  }
].reverse()

const Blog = () => {
  return (
    <div>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl">
          <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Latest & greatest
          </h2>
          <p className="mt-2 text-lg/8 text-gray-600">
            What's new? What's working? What's not working? Find out here.
          </p>
          <div className="mt-10 space-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16">
            {posts.map((post) => (
              <article
                key={post.id}
                className="flex max-w-xl flex-col items-start justify-between"
              >
                <div className="flex items-center gap-x-4 text-xs">
                  <time dateTime={post.datetime} className="text-gray-500">
                    {post.date}
                  </time>
                  <p className="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600">
                    {post.category.title}
                  </p>
                </div>
                <div className="group relative">
                  <h3 className="mt-3 text-lg/6 font-semibold text-gray-900">
                    <span className="absolute inset-0" />
                    {post.title}
                  </h3>
                  <p className="mt-5 text-sm/6 text-gray-600">{post.description}</p>
                </div>
                <div className="relative mt-8 flex items-center gap-x-4">
                  <div className="text-sm/6">
                    <p className="text-gray-600">Handshakes & highfives,</p>
                    <p className="font-semibold text-gray-900">
                      <span className="absolute inset-0" />
                      {post.author.name}
                    </p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
